import React from "react";

const BG = "https://i.postimg.cc/t4YRDRbd/6390.jpg";

export default function HeroCard19() {
  return (
    <>
      <section className="charity-hero">
        <div className="charity-bg"></div>
        <div className="charity-overlay"></div>

        <div className="charity-card slide-in">
          <h3 className="charity-subtitle">
            <span>DONATORS</span> FOR A GOOD CAUSES
          </h3>

          <p className="charity-desc">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do 
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Maecenas 
            eget leo suscipit. Maecenas eget leo suscipit pellentesque eget.
          </p>

          <div className="charity-cta-row">
            <button className="cta-primary">Donate Now</button>
            <button className="cta-secondary">Raise Refund</button>
          </div>
        </div>
      </section>

      <style>{`
/* HERO SECTION */
.charity-hero {
  position: relative;
  height: 95vh;
  width: 100%;
  overflow: hidden;
}

/* Background image */
.charity-bg {
  background: url('${BG}') center/cover no-repeat;
  position: absolute;
  inset: 0;
  z-index: 1;
  filter: brightness(0.75);
}

/* large dark overlay (for blending) */
.charity-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.25);
  z-index: 2;
}

/* Left content card */
.charity-card {
  position: absolute;
  top: 50%;
  left: 8%;
  transform: translateY(-50%);
  z-index: 4;
  width: 420px;
  background: rgba(0,0,0,0.65);
  padding: 40px;
  border-radius: 6px;
  backdrop-filter: blur(4px);
  color: #fff;
}

/* Headings */
.charity-subtitle {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 16px;
  line-height: 1.2;
}
.charity-subtitle span {
  color: #ff5b57;
}

/* Description */
.charity-desc {
  margin-bottom: 26px;
  color: #e2e2e2;
  line-height: 1.6;
  font-size: 1.05rem;
}

/* CTA Buttons */
.charity-cta-row {
  display: flex;
  gap: 14px;
}

.cta-primary {
  background: #ff4743;
  padding: 12px 26px;
  border: none;
  color: #fff;
  border-radius: 4px;
  font-weight: 600;
}
.cta-secondary {
  background: #ffffff;
  color: #000;
  border: none;
  padding: 12px 26px;
  border-radius: 4px;
  font-weight: 600;
}

/* -------------------- PURE CSS ANIMATIONS -------------------- */

/* Card slide-in animation */
@keyframes slideIn {
  0% { opacity: 0; transform: translate(-40px, -50%); }
  100% { opacity: 1; transform: translate(0px, -50%); }
}
.slide-in {
  animation: slideIn 1.2s ease-out forwards;
}

/* Button hover */
.cta-primary:hover { background: #ff6c68; }
.cta-secondary:hover { background: #f0f0f0; }

/* Responsive */
@media (max-width: 768px) {
  .charity-card {
    width: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .charity-subtitle { font-size: 1.6rem; }
}
      `}</style>
    </>
  );
}
